import React from 'react'
import Overlay from '../Overlay/Overlay'
import { Spinner } from '../../funcs/utils'

const SpinningLoaderOverlay = ({ size }) => {
    return (
        <Overlay>
            <div style={{ position: 'relative', zIndex: '1001', color: 'black' }}>
                <Spinner size={size} />
            </div>
        </Overlay>
    )
}

export default SpinningLoaderOverlay